module.exports = __webpack_public_path__ + "static/mustache-ee829f8030aa063b3a8e4bab361f92cd.jpg";